const $ = sel => document.querySelector(sel);
const normalize = txt => (txt || '').trim().toLowerCase();

function _pickupMsgBox() {
    const picker = typeof getPicker === 'function' ? getPicker() : null;
    const root = picker?.closest('section') || document;
    // Prefer the message box in the same section; fall back to the first one
    return root.querySelector('[id^="pickup-messages-"]')
        || document.querySelector('[id^="pickup-messages-"]');
  }

  function getMessageTemplates() {
    const box = _pickupMsgBox();
    return {
      in:  box?.querySelector('.in')?.textContent  || 'Size {size} Available to pick up in 4 hours',
      low: box?.querySelector('.low')?.textContent || 'Size {size} Low stock. Ready in 4h to be picked up in store',
      out: box?.querySelector('.out')?.textContent || 'Size {size} will be shipped to store. Pick up in 2-3 days',
    };
  }

  function normalizeStockLevel(level) {
    const s = (level || '').trim().toLowerCase();
    if (s === 'out of stock') return 'out';
    if (s === 'low stock') return 'low';
    return 'in'; // everything else = in stock
  }

  function composeAvailabilityMessage(level, sizeLabel) {
    const t = getMessageTemplates();
    switch (normalizeStockLevel(level)) {
      case 'out': return t.out.replace('{size}', sizeLabel);
      case 'low': return t.low.replace('{size}', sizeLabel);
      default:    return t.in.replace('{size}', sizeLabel);
    }
  }

const getPicker = () => $('delivery-picker');
const getForm = () => $('form[id^="product-form-"]');

const getSizeMap = () => {
    const el = $('#sku-size-map');
    return el ? JSON.parse(el.textContent) : {};
};

async function previewInventory(colour) {
    const picker = getPicker();
    if (!picker) return [];
    const stylecode = picker.dataset.stylecode;
    const url = `https://sc1l9727g1.execute-api.ap-southeast-2.amazonaws.com/Prod/inventory/stock-lookup`
        + `?stylecode=${encodeURIComponent(stylecode)}`
        + `&colour=${encodeURIComponent(colour)}`;
    const json = await fetch(url).then(r => r.json()).catch(() => null);
    const locs = Array.isArray(json) ? json : json?.locations||[];
    inventoryCache[`${stylecode}|${colour}`] = locs;
    return locs;
}

function rebuildInventoryTables(locs, sizeMap) {
    const skus = Array.from(new Set(
        locs.flatMap(loc => loc.inventory.map(i => i.sku))
    ));

    document.querySelectorAll('.store-inventory').forEach(table => {
        // HEADER
        const headRow = table.querySelector('thead tr');
        const bodyRow = table.querySelector('tbody tr');
        const storeKey = table.closest('.store')?.dataset.store;
        const loc = locs.find(l => normalize(l.name) === normalize(storeKey));
        headRow.innerHTML = skus
            .map(sku => {
                const label = sizeMap[sku];
                return `<th data-sku="${sku}" data-status="${label}">${label}</th>`;
            })
            .join('');

        bodyRow.innerHTML = skus
            .map(sku => {
                const inv = loc?.inventory.find(i => i.sku === sku);
                const stock = inv?.stockLevel || '—';
                const stockHandle   = stock.replace(/\s/g, '-').toLowerCase();
                const label = sizeMap[sku];
                return `<td data-sku="${sku}" data-store="${storeKey}" data-status="${label}" class="${stockHandle}">${stock}</td>`;
            })
            .join('');
    });
}

let variantMap = {};
document.addEventListener('DOMContentLoaded', () => {
    const mapEl = document.getElementById('variant-id-sku-map');
    if (mapEl) variantMap = JSON.parse(mapEl.textContent);
});

const inventoryCache = Object.create(null);

const LS_STORE = () => {
    const h = getPicker()?.dataset.handle || 'unknown';
    return `pickupStore:handle:${h}`;
};
const LS_STOCK = () => {
    const p = getPicker();
    const h = p?.dataset.handle  || 'unknown';
    const s = p?.dataset.variantSku || 'unknown';
    return `pickupStock:${h}:${s}`;
};

async function setCartAttributes(obj) {
    await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ attributes: obj }),
    });
}

async function getInventory(stylecode, colour) {
    const key = `${stylecode}|${colour}`;
    if (inventoryCache[key]) return inventoryCache[key];

    const url = 'https://nn2kcb39qg.execute-api.ap-southeast-2.amazonaws.com/Prod/'
        + 'inventory/stock-lookup'
        + `?stylecode=${encodeURIComponent(stylecode)}`
        + `&colour=${encodeURIComponent(colour)}`;

    const json = await fetch(url).then(r => r.json()).catch(() => null);
    const locations = Array.isArray(json) ? json : json?.locations || [];

    inventoryCache[key] = locations;
    return locations;
}

function getStockLevel(sku, storeName, stylecode, colour) {
    const key = `${stylecode}|${colour}`;
    const locs = inventoryCache[key] || [];
  
    // Match directly without resolving store names
    const loc = locs.find(
      l => normalize(l.name) === normalize(storeName)
    );
  
    if (!loc) {
      console.warn("[getStockLevel] No location matched", {
        storeName,
        apiNames: locs.map(l => l.name)
      });
      return 'Out of Stock';
    }
  
    const inv = loc.inventory.find(i => i.sku === sku);
    return inv?.stockLevel || 'Out of Stock';
  }
  

document.addEventListener('DOMContentLoaded', () => {
    initPickupLogic().catch(console.error);
});

async function initPickupLogic() {
    const picker = getPicker();

    const cart = await fetch('/cart.js').then(r => r.json());

    const checkoutLoc = cart.attributes?._checkoutLocation || '';
    const currentAttrStore = cart.attributes?._storeName || '';
    const showAll = '_showAllLocations' in (cart.attributes || {});

    let actualStore   = checkoutLoc || currentAttrStore;
    const needResync  = checkoutLoc && normalize(checkoutLoc) !== normalize(currentAttrStore);

    if (needResync) {

        localStorage.setItem(LS_STORE(), checkoutLoc);

        await updateAllStockLevels(checkoutLoc);

        console.log('Setting cart attributes for store:', checkoutLoc);
        await setCartAttributes({
            _storeName:        checkoutLoc,
            _deliveryType:     'Pickup',
            _showAllLocations: ''
        });

    } else if (showAll) {
        await setCartAttributes({ _showAllLocations: '' });
    }

    if (picker && actualStore) {
        await getInventory(picker.dataset.stylecode, picker.dataset.colour);
        applyStoreSelection(actualStore);
    } else {
        prepareFormProperties('Ship it to me');
    }

    await ensureLinesOnPickup(actualStore);
}

async function ensureLinesOnPickup(storeName) {
    const cart = await fetch('/cart.js').then(r => r.json());

    if (cart.attributes?._deliveryType !== 'Pickup') return;

    const needFix = cart.items.some(
        i => (i.properties?._delivery_method || 'Ship it to me') !== 'Pick up in-store'
    );
    if (!needFix) return;

    await updateAllExistingDelivery('Pick up in-store', storeName);
}

function buildColourSelector() {
    const regionSel = document.getElementById('region-select');
    if (!regionSel) return;

    document.getElementById('colour-select')?.remove();

    const swatches = Array.from(document.querySelectorAll('.product-info__product-picker .color-swatch'));
    if (!swatches.length) return;

    const sel = document.createElement('select');
    sel.id = 'colour-select';
    sel.className = 'colour-select ml-2';

    swatches.forEach(a => {
        const colour = a.querySelector('span')?.textContent.trim();
        if (!colour) return;
        const opt = document.createElement('option');
        opt.value = colour;
        opt.textContent = colour;
        if (a.classList.contains('is-selected')) opt.selected = true;
        sel.appendChild(opt);
    });

    regionSel.insertAdjacentElement('afterend', sel);
}

window.checkStoreAvailability = openAvailability;

function openAvailability(btn) {
    const picker = getPicker();
    if (!btn || !picker) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    const pending = picker.dataset.pendingColour;
    const colourToUse = pending || picker.dataset.colour;

    previewInventory(colourToUse)
        .then(locs => {
            if (pending) {
                const swatchLink = Array.from(
                    document.querySelectorAll('.product-info__product-picker .color-swatch')
                ).find(a => a.querySelector('span')?.textContent.trim() === pending);

                if (swatchLink) {
                    return fetch(swatchLink.href)
                        .then(r => r.text())
                        .then(html => {
                            const doc   = new DOMParser().parseFromString(html, 'text/html');
                            const mapEl = doc.getElementById('sku-size-map');
                            const newMap = mapEl ? JSON.parse(mapEl.textContent) : getSizeMap();
                            return { locs, sizeMap: newMap };
                        });
                }
            }

            return { locs, sizeMap: getSizeMap() };
        })
        .then(({ locs, sizeMap }) => {

            rebuildInventoryTables(locs, sizeMap);

            buildPopup(locs);

            if (!document.getElementById('colour-select')) {
                buildColourSelector();
            }
        })
        .catch(err => {
            console.error('Availability Load Error:', err);
            const pop = $('#storeAvailabilityPopup .popup-slideout');
            if (pop) {
                pop.querySelector('.store-list').innerHTML =
                    '<p class="text-red-600">Failed to load availability.</p>';
                $('#storeAvailabilityPopup')?.classList.remove('hidden');
            }
        })
        .finally(() => {
            btn.disabled = false;
            btn.classList.remove('is-loading');
        });
}
window.closePopup = () => $('#storeAvailabilityPopup')?.classList.add('hidden');

document.addEventListener('change', e => {
    if (e.target.id !== 'region-select') return;
    const region = e.target.value;
    document
        .querySelectorAll('#storeAvailabilityPopup .store')
        .forEach(storeCard => {
            storeCard.style.display =
                !region || storeCard.dataset.region === region
                    ? 'flex'
                    : 'none';
        });
});
document.addEventListener('change', e => {
    if (e.target.id !== 'colour-select') return;
    const picker    = getPicker();
    const newColour = e.target.value;
    const loader    = document.getElementById('popup‐loader');
    if (!picker) return;

    loader.classList.remove('hidden');

    picker.dataset.pendingColour = newColour;
    document.getElementById('region-select').value = '';

    previewInventory(newColour)
        .then(locs => {

            const swatchLink = Array.from(
                document.querySelectorAll('.product-info__product-picker .color-swatch')
            ).find(a => a.querySelector('span')?.textContent.trim() === newColour);

            if (!swatchLink) {
                const currentMap = getSizeMap();
                rebuildInventoryTables(locs, currentMap);
                updateStockLevels(locs);
                updateAvailabilityBadge(localStorage.getItem(LS_STORE()), picker.dataset.variantSku);
                return;
            }

            fetch(swatchLink.href)
                .then(r => r.text())
                .then(html => {
                    const doc   = new DOMParser().parseFromString(html, 'text/html');
                    const mapEl = doc.getElementById('sku-size-map');
                    const newMap = mapEl ? JSON.parse(mapEl.textContent) : {};

                    rebuildInventoryTables(locs, newMap);

                    const popup = document.getElementById('storeAvailabilityPopup');
                    popup.querySelectorAll('.store').forEach(c => c.style.display = 'none');
                    locs.forEach(loc => {
                        const card = popup.querySelector(
                            `.store[data-store="${normalize(loc.name)}"]`
                        );
                        if (card) card.style.display = 'flex';
                    });

                    const saved = localStorage.getItem(LS_STORE());
                    if (saved) {
                        updateAvailabilityBadge(saved, picker.dataset.variantSku);
                    }
                })
                .catch(console.error);
        })
        .catch(console.error)
        .finally(() => {

            loader.classList.add('hidden');
        });

    const regionSel = document.getElementById('region-select');
    if (regionSel) {
        regionSel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return;
});

document.addEventListener('change', e => {
    if (e.target.name !== 'delivery-method') return;

    if (e.target.id === 'ship-it-to-me') {
        clearStoreSelection();
        return;
    }

    if (e.target.id === 'pick-up-in-store') {
        const saved  = localStorage.getItem(LS_STORE());
        const picker = getPicker();
        if (!saved || !picker) return;

        getInventory(picker.dataset.stylecode, picker.dataset.colour)
            .then(() => applyStoreSelection(saved))
            .catch(console.error);
    }
});

document.addEventListener('change', e => {
    if (e.target.type !== 'radio' || !e.target.closest('variant-picker')) return;

    const sku = e.target.dataset.variantSku;
    if (!sku) return;
    const sizeLabel = getSizeMap()[sku] || sku;
    const picker = getPicker();
    picker.dataset.variantSku = sku;

    const saved = localStorage.getItem(LS_STORE());
    if (saved && inventoryCache) updateAvailabilityBadge(saved, sku);

    if (e.target.name === 'delivery-method' && e.target.id === 'pick-up-in-store') {
        const saved = localStorage.getItem(LS_STORE());
        const picker = getPicker();
        if (saved && picker) {
            getInventory(picker.dataset.stylecode, picker.dataset.colour)
                .then(() => applyStoreSelection(saved))
                .catch(console.error);
        }
    }

    const badge = getPicker().querySelector('.selected-store');
    if (!badge) return;

    // Update .store-size-info with both size and availability
    const style = picker.dataset.stylecode;
    const colour = picker.dataset.colour;
    const level = getStockLevel(sku, saved, style, colour);
    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);
});

function updateAvailabilityBadge(storeName, sku) {
    const picker = getPicker();
    if (!picker) return;

    const badge = picker.querySelector('.selected-store');
    if (!badge) return;

    const sizeMap = getSizeMap();
    const sizeLabel = sizeMap[sku] || sku;
    const level = getStockLevel(
        sku,
        storeName,
        picker.dataset.stylecode,
        picker.dataset.colour,
    );

    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);


    localStorage.setItem(LS_STOCK(), level);

    const form = getForm();
    if (form) {
        removeProp(form, '_stockLevel');
        setProp(form, '_stockLevel', level);
    }
}

function buildPopup(locs) {
    $('#storeAvailabilityPopup')?.classList.remove('hidden');
    document.querySelectorAll('.store').forEach(el => el.style.display = 'none');
    locs.forEach(loc => {
        const card = $(`.store[data-store="${normalize(loc.name)}"]`);
        if (card) card.style.display = 'flex';
    });
    $('#region-select').value = '';
    updateStockLevels(locs);

    const saved = localStorage.getItem(LS_STORE());
    document.querySelectorAll('#storeAvailabilityPopup .select-store')
        .forEach(btn => btn.classList.toggle(
            'selected',
            btn.dataset.storeName === saved
        ));
}

async function updateStockLevels(locs) {
    const picker = getPicker();

    const sel = document.getElementById('colour-select');
    const popupColour = sel?.value;
    let sizeMap = getSizeMap();

    if (popupColour && popupColour !== picker.dataset.colour) {

        await previewInventory(popupColour);

        const swatchLink = Array.from(
            document.querySelectorAll('.product-info__product-picker .color-swatch')
        ).find(a => a.querySelector('span')?.textContent.trim() === popupColour);

        if (swatchLink) {
            try {
                const html = await fetch(swatchLink.href).then(r => r.text());
                const doc  = new DOMParser().parseFromString(html, 'text/html');
                const mapEl = doc.getElementById('sku-size-map');
                if (mapEl) sizeMap = JSON.parse(mapEl.textContent);
            } catch (err) {
                console.error('Failed to update sizeMap for', popupColour, err);

            }
        }
    }

    locs.forEach(loc => {
        loc.inventory.forEach(({ sku, stockLevel }) => {
            const cell = $(`td[data-sku="${sku}"][data-store="${normalize(loc.name)}"]`);
            if (!cell) return;
            cell.textContent = stockLevel;
            cell.className   = stockLevel.replace(/\s/g, '-').toLowerCase();

            const th = cell.closest('table').querySelector(`th[data-sku="${sku}"]`);
            if (th) th.textContent = sizeMap[sku] || sku;
        });
    });
}

document.addEventListener('click', e => {
    if (!e.target.classList.contains('select-store')) return;
    const btns = document.querySelectorAll('#storeAvailabilityPopup .select-store');
    btns.forEach(b => b.classList.remove('selected'));
    e.target.classList.add('selected');
    const picker   = getPicker();
    const pending  = picker?.dataset.pendingColour;
    const store    = e.target.dataset.storeName;

    if (pending && pending !== picker.dataset.colour) {
        const swatchLink = Array.from(
            document.querySelectorAll('.product-info__product-picker .color-swatch')
        ).find(a => a.querySelector('span')?.textContent.trim() === pending);
        if (swatchLink) {
            const currentSku  = picker.dataset.variantSku;
            const sizeLabel   = getSizeMap()[currentSku];
            localStorage.setItem(LS_STORE(), store);
            localStorage.setItem(LS_STOCK(), getStockLevel(picker.dataset.variantSku, store, picker.dataset.stylecode, pending));
            fetch(swatchLink.href)
                .then(r => r.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const newSizeMapEl = doc.getElementById('sku-size-map');
                    const newSizeMap= newSizeMapEl ? JSON.parse(newSizeMapEl.textContent) : {};

                    const newVarMapEl  = doc.getElementById('variant-id-sku-map');
                    const newVarMap    = newVarMapEl ? JSON.parse(newVarMapEl.textContent) : {};

                    const skuToId = Object.fromEntries(
                        Object.entries(newVarMap).map(([id, sku]) => [sku, id])
                    );

                    const newSku = Object.entries(newSizeMap)
                        .find(([, label]) => label === sizeLabel)?.[0];

                    let url = swatchLink.href;
                    if (newSku && skuToId[newSku]) {
                        const vid = skuToId[newSku];
                        const sep = url.includes('?') ? '&' : '?';
                        url = url + sep + 'variant=' + vid;
                    }

                    picker.dataset.colour = pending;
                    window.location.href = url;
                })
                .catch(err => {
                    console.error('Redirect error:', err);

                    picker.dataset.colour = pending;
                    window.location.href = swatchLink.href;
                });
            return;
        }
    }

    applyStoreSelection(store);
    closePopup();
});

let skipNextClick = false;
document.addEventListener('click', async e => {
    const btn  = e.target.closest('button[type="submit"]');
    const form = getForm();
    if (!btn || !form || btn.form !== form) return;
    if (skipNextClick) { skipNextClick = false; return; }

    e.preventDefault();

    const wantsPickup = !!$('#pick-up-in-store')?.checked;
    const pickedStore = localStorage.getItem(LS_STORE());
    if (wantsPickup && !pickedStore) {
        showStoreError();
        return;
    }

    const intended    = wantsPickup ? 'Pick up in-store' : 'Ship it to me';
    const intendedAttr= wantsPickup ? 'Pickup' : 'Shipping';

    const cart = await fetch('/cart.js').then(r => r.json());
    const currentAttr   = cart.attributes?._deliveryType || 'Shipping';
    const firstItem     = cart.items.find(i => i.properties?._delivery_method);
    const currentMethod = firstItem?.properties._delivery_method || null;

    const confirmAndGo = async () => {
        await updateAllExistingDelivery(intended);
        await setCartAttributes({
            _deliveryType: intendedAttr,
            _storeName:    wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
            _checkoutLocation: wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
        });
        prepareFormProperties(intended);
        skipNextClick = true;
        setTimeout(() => btn.click(), 0);
    };

    if (currentAttr !== intendedAttr || (currentMethod && currentMethod !== intended)) {
        showSwitchModal(currentMethod ?? currentAttr, intended, confirmAndGo);
    } else {
        prepareFormProperties(intended);
        await setCartAttributes({
            _deliveryType: intendedAttr,
            _storeName:    wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
            _checkoutLocation: wantsPickup ? pickedStore : ''
        });
        skipNextClick = true;
        setTimeout(() => btn.click(), 0);
    }
});

function showStoreError() {
    const picker = getPicker();
    if (!picker) return;

    if (picker.querySelector('.store-error')) return;

    const p = document.createElement('p');
    p.className = 'store-error mt-1 text-sm text-red-600';
    p.textContent = 'Please select store.';
    picker.querySelector('.pickup .block-swatch').appendChild(p);

    const remove = () => { p.remove(); document.removeEventListener('store-picked', remove); clearTimeout(timeoutId);};
    document.addEventListener('store-picked', remove);

    const timeoutId = setTimeout(remove, 10000);
}

function applyStoreSelection(storeName) {
    const picker = getPicker();
    const form   = getForm();
    if (!picker || !form) return;

    $('#pick-up-in-store')?.click();

    let badge = picker.querySelector('.selected-store');
    if (!badge) {
        badge = document.createElement('span');
        badge.className = 'selected-store mt-2 text-sm';
        picker.querySelector('.pickup label').appendChild(badge);
    } else {
        badge.replaceChildren();
    }

    const sku = picker.dataset.variantSku;
    const sizeMap  = getSizeMap();
    const sizeLabel = sizeMap[sku] || sku;

    const storeSpan = document.createElement('span');
    storeSpan.textContent = storeName;
    badge.appendChild(storeSpan);

    // Find or create .store-size-info and update its text
    const style    = picker.dataset.stylecode;
    const colour   = picker.dataset.colour;
    const level    = getStockLevel(sku, storeName, style, colour);

    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);


    localStorage.setItem(LS_STORE(), storeName);
    localStorage.setItem(LS_STOCK(), level);

    setProp(form, '_delivery_method', 'Pick up in-store');
    setProp(form, '_stockLevel',      level);
    setProp(form, '_stylecode',       style);
    setProp(form, '_colour',          colour);

    updateAllStoreName(storeName).catch(console.error);
    updateAllStockLevels(storeName).catch(console.error);

    setCartAttributes({
        _deliveryType: 'Pickup',
        _storeName: storeName,
        _checkoutLocation: storeName
    }).catch(console.error);

    document.dispatchEvent(new Event('store-picked'));
}

function clearStoreSelection() {
    const picker = getPicker();
    const form   = getForm();
    picker?.querySelector('.selected-store')?.remove();

    removeProp(form, '_delivery_method');
    removeProp(form, '_store_name');
    removeProp(form, '_stockLevel');

    setProp(form, '_delivery_method', 'Ship it to me');

    localStorage.removeItem(LS_STORE());
    localStorage.removeItem(LS_STOCK());

    setCartAttributes({
        _deliveryType: 'Shipping',
        _storeName:    '',
        _checkoutLocation: '',

    }).catch(console.error);
}

async function updateAllExistingDelivery(newMethod, storeName = '') {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    if (!storeName) storeName = localStorage.getItem(LS_STORE()) || '';

    for (let i = 0; i < cart.items.length; i++) {
        const item    = cart.items[i];
        const current = item.properties?._delivery_method || 'Ship it to me';
        if (current === newMethod) continue;

        const props = { ...item.properties, _delivery_method: newMethod };
        if (newMethod === 'Pick up in-store') {
            props._stockLevel  = getStockLevel(
                item.sku,
                storeName,
                item.properties._stylecode,
                item.properties._colour,
            );
        } else {
            delete props._store_name;
            delete props._stockLevel;
        }

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: props }),
        });
    }

    await setCartAttributes({
        _deliveryType: newMethod === 'Pick up in-store' ? 'Pickup' : 'Shipping',
        _storeName:    newMethod === 'Pick up in-store' ? storeName : '',
        _checkoutLocation:    newMethod === 'Pick up in-store' ? storeName : '',
    });

    if (newMethod === 'Pick up in-store') await updateAllStockLevels(storeName);
}

async function updateAllStoreName(newStore) {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    for (let i = 0; i < cart.items.length; i++) {
        const item   = cart.items[i];
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') continue;

        const props = {
            ...item.properties,
            _delivery_method: method,
            _stockLevel:      getStockLevel(
                item.sku,
                newStore,
                item.properties._stylecode,
                item.properties._colour,
            ),
        };

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: props }),
        });
    }
}

async function updateAllStockLevels(storeName) {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    const needed = {};
    cart.items.forEach(item => {
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') return;
        const sc = item.properties._stylecode;
        const cl = item.properties._colour;
        if (sc && cl && !inventoryCache[`${sc}|${cl}`]) {
            needed[`${sc}|${cl}`] = { sc, cl };
        }
    });
    await Promise.all(
        Object.values(needed).map(({ sc, cl }) => getInventory(sc, cl)),
    );

    for (let i = 0; i < cart.items.length; i++) {
        const item   = cart.items[i];
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') continue;

        const level = getStockLevel(
            item.sku,
            storeName,
            item.properties._stylecode,
            item.properties._colour,
        );
        if (level === item.properties?._stockLevel) continue;

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({
                line: i + 1,
                quantity: item.quantity,
                properties: { ...item.properties, _stockLevel: level },
            }),
        });
    }
}

function setProp(form, label, value) {
    const name = `properties[${label}]`;
    let inp = form.querySelector(`[name="${name}"]`);
    if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        form.appendChild(inp);
    }
    inp.value = value;
}
function removeProp(form, label) {
    form.querySelector(`[name="properties[${label}]"]`)?.remove();
}

function prepareFormProperties(method) {
    const form = getForm();
    if (!form) return;

    removeProp(form, '_delivery_method');
    removeProp(form, '_store_name');
    removeProp(form, '_stockLevel');

    setProp(form, '_delivery_method', method);

    const picker = getPicker();
    const style  = picker.dataset.stylecode;
    const colour = picker.dataset.colour;

    setProp(form, '_stylecode', style || '');
    setProp(form, '_colour',    colour || '');

    if (method === 'Pick up in-store') {

        const lvl   = localStorage.getItem(LS_STOCK()) || 'Out of Stock';
        setProp(form, '_stockLevel', lvl);
    }
}

function showSwitchModal(from, to, onYes) {
    const modal = $('#switch-delivery-modal');
    modal.querySelector('[data-role="modalNotSelectedShippingMethod"]').textContent = `'${from}'`;
    modal.querySelector('[data-role="modalSelectedShippingMethod"]').textContent   = `'${to}'`;
    modal.classList.add('_show');
    modal.querySelector('.confirm').onclick = () => { modal.classList.remove('_show'); onYes(); };
    modal.querySelector('.delivery').onclick = () => modal.classList.remove('_show');
    modal.querySelector('.action-close').onclick = () => modal.classList.remove('_show');

}